import { tourKeys } from '../@utils/tourKeys'

export default function getHomeSteps() {
    const k = tourKeys('home')

    return [
        {
            target: '.sticky-header',
            contentKey: k.welcome,
            placement: 'bottom',
            disableBeacon: true,
        },
        {
            target: '.select-hotels-header',
            contentKey: k.selectHotels,
            placement: 'bottom',
            disableScrolling: true,
        },
        {
            target: '.select-dates-header',
            contentKey: k.selectDates,
            placement: 'bottom',
            disableScrolling: true,
        },
        {
            target: '.notifications-block',
            contentKey: k.notifications,
            placement: 'bottom',
            disableScrolling: true,
        },
        {
            target: '.currency-block',
            contentKey: k.currency,
            placement: 'bottom',
            disableScrolling: true,
        },
        {
            target: '.content-panel-home',
            contentKey: k.kpiCards,
            placement: 'bottom',
        },
        {
            target: '.ia-insights-card',
            contentKey: k.iaInsights,
            placement: 'top',
        },
        {
            target: '[data-tour="home-line-chart"]',
            contentKey: k.lineChart,
            placement: 'top',
        },
        {
            target: '.card-top-offenders',
            contentKey: k.ranking,
            placement: 'right',
        },
        {
            target: '[data-tour="home-ranking"]',
            contentKey: k.rankingCard,
            placement: 'left',
        },
        {
            target: '[data-tour="home-alerts"]',
            contentKey: k.alerts,
            placement: 'top',
        },
        {
            target: '[data-tour="home-events"]',
            contentKey: k.events,
            placement: 'top',
        },
        {
            target: '[data-tour="home-sites-status"]',
            contentKey: k.sitesStatus,
            placement: 'left',
        },
    ]
}
